<template>
  <div id="approvalManagement" class="common_contentBox">
    <div class="common_search">
      <el-row>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">配置类型：</div>
          <div class="content">
            <el-select v-model="form.configType" placeholder="请选择" @change="configTypeChange">
              <el-option
                v-for="item in configureTypeList"
                :key="item.code"
                :label="item.val"
                :value="item.code"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">费用归属部门：</div>
          <div class="content">
            <el-select v-model="form.deptCode" clearable filterable placeholder="请选择">
              <el-option
                v-for="item in expensesDeptList"
                :key="item.expeDeptCode"
                :label="item.expeDeptName"
                :value="item.expeDeptCode"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">费用类型：</div>
          <div class="content">
            <el-select v-model="form.expenseTypeCode" clearable placeholder="请选择">
              <el-option
                v-for="item in expensesTypeList"
                :key="item.expenseTypeCode"
                :label="item.expenseTypeName"
                :value="item.expenseTypeCode"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">审批人：</div>
          <div class="content">
            <el-select
              v-model="form.userId"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              :loading="saleLoading"
              clearable
            >
              <el-option v-for="item in saleList" :key="item.userId" :label="item.userName" :value="item.userId" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" />
        <div class="btnBar">
          <el-button plain @click="reset">重置</el-button>
          <el-button type="primary" @click="searchBtn">搜索</el-button>
        </div>
      </el-row>
    </div>
    <div class="common_btnBar">
      <el-button type="primary" @click="addHandlen">添加审批人</el-button>
    </div>
    <commonTable ref="approvalManagementTable" />
    <addApprovedDialog
      :config-type="form.configType"
      :approved-dialog-visible="approvedDialogVisible"
      :expenses-type-list="expensesTypeList"
      :edit-data="editData"
      @approvedSubmit="approvedSubmit"
      @approvedEdit="approvedEdit"
      @dialogCloseHandle="approvedDialogClose"
    />
  </div>
</template>
<script>
import commonTable from '@/components/commonTable';
import { TableRow, TableColumns } from '@/utils/tableOptions.js';
import { expensesJurManagementApi, budgetPerformanceApi, approvalManagementApi } from './service';
import addApprovedDialog from './component/approvalManagement/addApprovedDialog';

export default {
  data () {
    return {
      saleLoading: false,
      saleList: [],
      form: {
        configType: 1
      },
      tableData: [],
      expensesDeptList: [],
      expensesTypeList: [],
      configureTypeList: [
        {
          code: 1,
          val: '按费用部门和类型配置'
        },
        {
          code: 2,
          val: '行业拓展/大区渠道经理'
        },
        {
          code: 3,
          val: '按产品线配置'
        }
      ],
      approvedDialogVisible: false,
      editData: {}
    };
  },
  components: {
    commonTable,
    addApprovedDialog
  },
  computed: {},
  methods: {
    approvedDialogClose () {
      this.editData = {};
      this.approvedDialogVisible = false;
    },
    editHandlen (row) {
      this.editData = JSON.parse(JSON.stringify(row));
      this.approvedDialogVisible = true;
    },
    remoteMethod (query) {
      if (query !== '') {
        this.saleLoading = true;
        approvalManagementApi.getApproveUserList(query).then(res => {
          if (res.status === '200') {
            this.saleList = res.data ? res.data : [];
          }
          this.saleLoading = false;
        });
      } else {
        this.saleList = [];
      }
    },
    configTypeChange () {
      let { configType } = this.form;
      this.form = {
        configType: configType
      };
      this.$refs.approvalManagementTable.pageData.pageNum = 1;
      this.loadTable(configType);
    },
    deleteHandle (row) {
      let { configType } = this.form;
      this.$confirm('确定删除此审批人?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        approvalManagementApi.deleteApproveUser({ id: row.id, type: configType }).then(res => {
          if (res.status === '200') {
            this.loadTable(configType);
            this.$message.success('删除成功');
          }
        });
      }).catch(() => {

      });
    },
    approvedSubmit (data) {
      this.$store.commit('setSubPageLoading', true);
      approvalManagementApi.addApproveUser(data).then(res => {
        if (res.status === '200') {
          this.loadTable(data.configType);
          this.approvedDialogVisible = false;
          this.$message.success('提交成功');
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    approvedEdit (data) {
      this.$store.commit('setSubPageLoading', true);
      approvalManagementApi.editApproveUser(data).then(res => {
        if (res.status === '200') {
          this.loadTable(data.configType);
          this.approvedDialogVisible = false;
          this.$message.success('编辑成功');
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    addHandlen () {
      this.approvedDialogVisible = true;
    },
    reset () {
      this.form = {
        configType: 1
      };
      this.searchBtn();
    },
    searchBtn () {
      this.$refs.approvalManagementTable.pageData.pageNum = 1;
      this.$refs.approvalManagementTable.getTableData({ url: 'approveuser/list', params: this.form });
    },
    loadTable (data) {
      switch (data) {
        case 1:
          this.loadCostDeptTable();
          break;
        case 2:
          this.loadAreaTable();
          break;
        default:
          this.loadProductLineTable();
      }
    },
    loadCostDeptTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title('费用归属部门编号')
          ._width('10%')
          ._data('deptCode')
      );
      tableRow.push(
        new TableColumns()
          ._title('费用归属部门')
          ._width('8%')
          ._data('deptName')
      );
      tableRow.push(
        new TableColumns()
          ._title('费用类型')
          ._width('10%')
          ._data('expenseTypeName')
      );
      tableRow.push(
        new TableColumns()
          ._title('邮箱前缀')
          ._width('8%')
          ._data('userId')
      );
      tableRow.push(
        new TableColumns()
          ._title('审批人')
          ._width('8%')
          ._data('userName')
      );
      tableRow.push(
        new TableColumns()
          ._title('角色')
          ._width('10%')
          ._data('userRole')
      );
      tableRow.push(
        new TableColumns()
          ._title('更新时间')
          ._width('8%')
          ._data('updateTime')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let date = new Date(row[column.property].replace(/-/g, '/')).format('yyyy-MM-dd');
              return (
                <span>{ date }</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('更新人')
          ._width('8%')
          ._data('updateUser')
      );
      tableRow.push(
        new TableColumns()
          ._title('操作')
          ._width('12%')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="text" onClick={() => {
                    this.editHandlen(row);
                  }}>编辑
                  </el-button>
                  <el-button type="text" onClick={() => {
                    this.deleteHandle(row);
                  }}>删除
                  </el-button>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.createTable(column);
    },
    loadAreaTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title('费用归属部门编号')
          ._width('10%')
          ._data('deptCode')
      );
      tableRow.push(
        new TableColumns()
          ._title('费用归属部门')
          ._width('10%')
          ._data('deptName')
      );
      tableRow.push(
        new TableColumns()
          ._title('大区部门编号')
          ._width('8%')
          ._data('areaDeptCode')
      );
      tableRow.push(
        new TableColumns()
          ._title('大区部门名称')
          ._width('10%')
          ._data('areaDeptName')
      );
      tableRow.push(
        new TableColumns()
          ._title('邮箱前缀')
          ._width('8%')
          ._data('userId')
      );
      tableRow.push(
        new TableColumns()
          ._title('审批人')
          ._width('8%')
          ._data('userName')
      );
      tableRow.push(
        new TableColumns()
          ._title('更新时间')
          ._width('8%')
          ._data('updateTime')
      );
      tableRow.push(
        new TableColumns()
          ._title('更新人')
          ._width('8%')
          ._data('updateUser')
      );
      tableRow.push(
        new TableColumns()
          ._title('操作')
          ._width('12%')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="text" onClick={() => {
                    this.editHandlen(row);
                  }}>编辑
                  </el-button>
                  <el-button type="text" onClick={() => {
                    this.deleteHandle(row);
                  }}>删除
                  </el-button>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.createTable(column);
    },
    loadProductLineTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title('产品线')
          ._width('8%')
          ._data('deptName')
      );
      tableRow.push(
        new TableColumns()
          ._title('邮箱前缀')
          ._width('8%')
          ._data('userId')
      );
      tableRow.push(
        new TableColumns()
          ._title('审批人')
          ._width('10%')
          ._data('userName')
      );
      tableRow.push(
        new TableColumns()
          ._title('更新时间')
          ._width('10%')
          ._data('updateTime')
      );
      tableRow.push(
        new TableColumns()
          ._title('更新人')
          ._width('8%')
          ._data('updateUser')
      );
      tableRow.push(
        new TableColumns()
          ._title('操作')
          ._width('12%')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="text" onClick={() => {
                    this.editHandlen(row);
                  }}>编辑
                  </el-button>
                  <el-button type="text" onClick={() => {
                    this.deleteHandle(row);
                  }}>删除
                  </el-button>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.createTable(column);
    },
    createTable (column) {
      this.$refs.approvalManagementTable.setColumn(column);
      this.$refs.approvalManagementTable.loadTable({ url: 'approveuser/list', listKey: 'list', params: this.form });
    },
    getExpensesDeptList () {
      expensesJurManagementApi.getExpenseDeptList().then(res => {
        if (res.status === '200') {
          this.expensesDeptList = res.data;
        }
      });
    },
    getExpenseTypeList () {
      budgetPerformanceApi.getExpenseTypeList().then(res => {
        if (res.status === '200') {
          this.expensesTypeList = res.data;
        }
      });
    }
  },
  mounted () {
    this.loadCostDeptTable();
    this.getExpensesDeptList();
    this.getExpenseTypeList();
  }
};
</script>
<style lang="scss" scoped>
#approvalManagement {
  width: 100%;

  .common_button {
    margin-bottom: 16px;
  }
}
</style>
